module.exports = __webpack_public_path__ + "img/Project-ONDA.cbb527b.jpg";